/* eslint-disable @typescript-eslint/no-floating-promises */
// @todo 后面看咋整理下位置吧 感觉比较奇特 虽然是自己写的 hhhhh
// import {SaveTplDialog} from '@/domains/document/DocHome/common/TemplateArea';
import * as store from '@/store/index';
import assert from 'assert';
import toast, {ToastType} from '@/components/Toast';
import {useIntl} from 'react-intl';
import sdk from '@/sdk';
import {DOC_TYPE} from '@/constants/document/doc';
import {importAsyncComponent} from '@/utils/loadable';

const SaveTplDialog = importAsyncComponent(() => {
    return import('@/domains/document/DocHome/common/TemplateArea').then((modules) => {
        return {
            default: modules.SaveTplDialog,
        };
    });
});

function handleTplDialogClose() {
    store.setShowSaveTplDialog(false);
}

interface StarCompProps {
    curDocument?: WizDocument;
    curRepository?: Repository;
    showSaveTplDialog?: boolean;
}

function SaveTplDialogBiz({
    curDocument,
    curRepository,
    showSaveTplDialog = false,
}: StarCompProps) {
    const intl = useIntl();
    const isTeamCatalog = curDocument?.type === DOC_TYPE.DIRECTORY;
    async function handleSaveTpl(value: string) {
        try {
            assert(curRepository);
            assert(curDocument);
            await sdk.as.createRepositoryTemplate(
                curRepository.spaceGuid,
                curRepository.groupGuid,
                curRepository.repositoryGuid,
                {
                    name: value,
                    intro: '',
                    created: curRepository.created as number,
                    docGuid: curDocument?.docGuid || '',
                    version: store.getRwMode() ? 'latest' : (curDocument?.version || ''),
                }
            );
            store.setShowSaveTplDialog(false);
            toast({
                type: ToastType.Success,
                content: intl.formatMessage({id: 'toastTemplateCreated'}),
            });
        } catch {
            toast({
                type: ToastType.Error,
                content: intl.formatMessage({id: 'toastCreateTemplateError'}),
            });
        }

    }

    return (<SaveTplDialog
        visible={showSaveTplDialog}
        onCancel={handleTplDialogClose}
        onSave={handleSaveTpl}
        isTeamCatalog={isTeamCatalog}
    />);
}

export default store.connect([
    store.KEYS.SHOW_SAVE_TPL_DIALOG,
])(SaveTplDialogBiz);
